/**
 * @deprecated Use CaseStepBreakdownChart instead. This component is maintained
 * for backward compatibility only and will be removed in a future version.
 */
import React, { useEffect } from 'react';

import { ChartDataItem } from '../../models/ChartTypes';
import { CaseStepBreakdownChart, StepData } from '../Charts/CaseStepBreakdownChart';
import { getActivityColor } from '../../utils/caseUtils';

/**
 * Maps legacy ChartDataItem[] to new StepData[] format.
 */
function mapChartDataToStepData(chartData: ChartDataItem[]): StepData[] {
  return chartData.map(item => ({
    name: item.name,
    time: item.time,
    displayTime: item.displayTime,
    color: getActivityColor(item.name),
  }));
}

/**
 * @deprecated Use CaseStepBreakdownChart instead. This component is maintained
 * for backward compatibility only and will be removed in a future version.
 */
const CaseEfficiencyTotalsMobile = (
  { chartData, onSegmentClick }: { chartData: ChartDataItem[], onSegmentClick: (segment_name: string) => void }
): React.JSX.Element => {
  useEffect(() => {
    console.warn('CaseEfficiencyTotalsMobile is deprecated. Use CaseStepBreakdownChart instead.');
  }, []);

  const stepData = mapChartDataToStepData(chartData);
  const totalTime = stepData.reduce((sum, step) => sum + step.time, 0);
  const totalHours = Math.floor(totalTime / 60);
  const totalMins = Math.floor(totalTime % 60);
  const totalStepTime = totalHours > 0
    ? `${totalHours} hr ${totalMins > 0 ? totalMins + ' min' : ''}`.trim()
    : `${totalMins} mins`;

  const handleSegmentClick = (step: StepData): void => {
    onSegmentClick(step.name);
  };

  return (
    <CaseStepBreakdownChart
      data={stepData}
      totalStepTime={totalStepTime}
      onSegmentClick={handleSegmentClick}
    />
  );
};

export default CaseEfficiencyTotalsMobile;
